import type { EnumType } from "~/kernel/enums/EnumType";

const ReviewCommentAuthor = Object.freeze({
  Company: "company",
  User: "user",
});

type ReviewCommentAuthor = EnumType<typeof ReviewCommentAuthor>;

export default ReviewCommentAuthor;
